module.exports = __webpack_public_path__ + "assets/RTrBy2SidePoints.3ef20876b367c66cd3ab366f642fba1f.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/RTrBy2SidePoints.gmt
// module id = 986
// module chunks = 0